module.exports = __webpack_public_path__ + "8eb1e0e559b7fb35fed99836b2eed7b9.svg";